(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      console.log('hide()');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      console.log('reveal()');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class HommegirlsProductGrid extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    init() {
      this.loadMoreBtn = this.parentElement.querySelector('.collection__load-more');
      if (!this.loadMoreBtn) return;
      this.observer = new IntersectionObserver(this.onIntersect.bind(this), { rootMargin: '200px' });
      this.observer.observe(this.loadMoreBtn);
    }

    async onIntersect(entries) {
      if (!entries[0].isIntersecting || this.loading) return;
      await this.loadMore();
    }

    async loadMore() {
      const url = this.loadMoreBtn.href;
      if (!url) return;
      this.loading = true;
      this.loadMoreBtn.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const newGrid = doc.querySelector('hommegirls-product-grid');
        if (newGrid) {
          [...newGrid.children].forEach(el => this.appendChild(el));
        }

        const nextBtn = doc.querySelector('.collection__load-more');
        if (nextBtn) {
          this.loadMoreBtn.href = nextBtn.href;
        } else {
          this.observer.disconnect();
          this.loadMoreBtn.remove();
          this.loadMoreBtn = null;
        }
      } catch (e) {
        console.error('Failed to load more products', e);
      } finally {
        this.loading = false;
        if (this.loadMoreBtn) this.loadMoreBtn.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('hommegirls-product-grid', HommegirlsProductGrid);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const carousel = document.querySelector('.js-carousel');

  function onCarouselButtonClick(ev) {
    if (!carousel) {
      return;
    }

    ev.preventDefault();
    const direction = 1 * (ev.currentTarget.getAttribute('data-direction') || 1);
    const screenWidth = window.innerWidth;
    const slides = carousel.children.length;
    const current = Math.round(carousel.scrollLeft / screenWidth);

    const next = direction > 0
      ? Math.min(slides - 1, current + 1)
      : Math.max(0, current - 1);

    carousel.scrollTo({
      top: 0,
      left: next * screenWidth,
      behavior: 'smooth',
    });
  }

  document.querySelectorAll('.js-carousel-button').forEach((el) => {
    el.addEventListener('click', onCarouselButtonClick);
  });

  } catch(e) { console.error(e); }
})();
})();
